// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroThumbnailStack-cls1_rT7","cls2":"HeroThumbnailStack-cls2_YEf HeroThumbnailStack-cls1_rT7"};